import { NgModule } from '@angular/core';
import { FormatCurrencyDirective } from './format-currency.directive';
import { FormatNumberDirective } from './format-number.directive';

@NgModule({
  declarations: [FormatCurrencyDirective, FormatNumberDirective],

  exports: [FormatCurrencyDirective, FormatNumberDirective],
})
export class DirectiveModule {}
